"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MBSwitch = exports.IMBSwitchVariant = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var styled_components_1 = __importDefault(require("styled-components"));
var core_1 = require("@material-ui/core");
var MBText_1 = require("../MBText");
var mock_1 = require("../../utils/mock");
var IMBSwitchVariant;
(function (IMBSwitchVariant) {
    IMBSwitchVariant[IMBSwitchVariant["large"] = 0] = "large";
    IMBSwitchVariant[IMBSwitchVariant["medium"] = 1] = "medium";
    IMBSwitchVariant[IMBSwitchVariant["small"] = 2] = "small";
})(IMBSwitchVariant = exports.IMBSwitchVariant || (exports.IMBSwitchVariant = {}));
/**
 * MBSwitch
 * ===
 * @description Meetbutter's custom Switch designed according to Verse UI kit
 *
 */
exports.MBSwitch = react_1.forwardRef(function (_a, ref) {
    var _b = _a.disabled, disabled = _b === void 0 ? false : _b, labelText = _a.labelText, labelTextTVal = _a.labelTextTVal, _c = _a.variant, variant = _c === void 0 ? IMBSwitchVariant.large : _c, _d = _a.labelPosition, labelPosition = _d === void 0 ? 'right' : _d, _e = _a.width, width = _e === void 0 ? '100%' : _e, name = _a.name, boxProps = _a.boxProps, onChange = _a.onChange, onFocus = _a.onFocus, onBlur = _a.onBlur, checked = _a.checked;
    return (jsx_runtime_1.jsxs(StyledLabel, __assign({ width: width, disabled: disabled }, boxProps, { children: [labelPosition === 'left' && labelText && (jsx_runtime_1.jsx(StyledText, { mr: 1, labelText: labelText, labelTextTVal: labelTextTVal, variant: variant }, void 0)),
            jsx_runtime_1.jsx(StyledSwitch, { inputRef: ref, disabled: disabled, variant: variant, name: name, checked: checked, onChange: onChange, onFocus: onFocus, onBlur: onBlur }, void 0),
            labelPosition === 'right' && labelText && (jsx_runtime_1.jsx(StyledText, { ml: 1, labelText: labelText, labelTextTVal: labelTextTVal, variant: variant }, void 0))] }), void 0));
});
var StyledText = styled_components_1.default(function (_a) {
    var labelText = _a.labelText, labelTextTVal = _a.labelTextTVal, rest = __rest(_a, ["labelText", "labelTextTVal"]);
    return jsx_runtime_1.jsx(MBText_1.MBText, __assign({ t: labelText, tVal: labelTextTVal }, rest), void 0);
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  && {\n    ", "\n  }\n"], ["\n  && {\n    ",
    "\n  }\n"])), function (_a) {
    var variant = _a.variant, theme = _a.theme;
    switch (variant) {
        case IMBSwitchVariant.small:
            return "\n            " + theme.typography.label + "\n          ";
        case IMBSwitchVariant.medium:
            return "\n            " + theme.typography.body3 + "\n          ";
        case IMBSwitchVariant.large:
            return "\n            " + theme.typography.body2 + "\n          ";
        default:
            return "";
    }
});
var StyledSwitch = styled_components_1.default(function (_a) {
    var variant = _a.variant, inputRef = _a.inputRef, rest = __rest(_a, ["variant", "inputRef"]);
    mock_1.mockFunction({ variant: variant });
    return jsx_runtime_1.jsx(core_1.Switch, __assign({}, rest, { ref: inputRef, color: "primary" }), void 0);
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  && {\n    border-radius: 33px;\n\n    ", "\n  }\n"], ["\n  && {\n    border-radius: 33px;\n\n    ",
    "\n  }\n"])), function (_a) {
    var variant = _a.variant;
    switch (variant) {
        case IMBSwitchVariant.small:
            return "\n            width: 32px;\n            height: 16px;\n            .MuiSwitch-thumb {\n              width: 12px;\n              height: 12px;\n            }\n            .Mui-checked {\n              transform: translateX(14px);\n            }\n          ";
        case IMBSwitchVariant.medium:
            return "\n            width: 40px;\n            height: 20px;\n            .MuiSwitch-thumb {\n              width: 16px;\n              height: 16px;\n            }\n            .Mui-checked {\n              transform: translateX(18px);\n            }\n          ";
        case IMBSwitchVariant.large:
            return "\n            width: 48px;\n            height: 24px;\n            .MuiSwitch-thumb {\n              width: 20px;\n              height: 20px;\n            }\n            .Mui-checked {\n              transform: translateX(22px);\n            }\n          ";
        default:
            return "";
    }
});
var StyledLabel = styled_components_1.default(function (_a) {
    var variant = _a.variant, disabled = _a.disabled, rest = __rest(_a, ["variant", "disabled"]);
    mock_1.mockFunction({ variant: variant, disabled: disabled });
    return jsx_runtime_1.jsx(core_1.Box, __assign({ component: "label", display: "flex", alignItems: "center" }, rest), void 0);
})(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  && {\n    ", "\n    ", "\n  }\n"], ["\n  && {\n    ",
    "\n    ",
    "\n  }\n"])), function (_a) {
    var theme = _a.theme, disabled = _a.disabled;
    return !disabled &&
        "\n      :hover {\n        > " + StyledSwitch + " {\n          background-color: " + theme.colors.primary.IceterineYellow10 + ";\n        }\n      }\n    ";
}, function (_a) {
    var theme = _a.theme, disabled = _a.disabled;
    return disabled &&
        "\n        color: " + theme.colors.basic.Grey30 + ";\n      ";
});
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=MBSwitch.js.map